module.exports = __webpack_public_path__ + "img/balance-plus.2cd684a4.svg";